import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 7v5l2 2","key":"svg-0"}],["path",{"d":"M17 22l5 -3l-5 -3l0 6","key":"svg-1"}],["path",{"d":"M13.017 20.943a9 9 0 1 1 7.831 -7.292","key":"svg-2"}]]

const IconClockPlay = createReactComponent('outline', 'clock-play', 'ClockPlay', __iconNode);

export default IconClockPlay;